import { Language } from '^/types';

export default {
  create: {
    [Language.KO_KR]: '새 카테고리 만들기',
    [Language.EN_US]: 'Create a new type labeled',
  },
};
